// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable, filter, map, take } from 'rxjs';
import { authPortalUserState } from '../app-states/app.state';
import { AppEnvironmentService } from '../services/app-environment.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class SuspendedTenantGuard {

    constructor(private store: Store, private appEnv: AppEnvironmentService, private router: Router) {

    }

    canActivate(): Observable<boolean> {
        return this.store.pipe(select(authPortalUserState)).pipe(
            filter(authUserState => authUserState.status === 'loaded'),
            take(1),
            map(authUserState => {

                if (authUserState.currentTenantId && authUserState.authUser) {
                    const tenantProfile = authUserState.authUser.getTenantProfile(authUserState.currentTenantId);
                    if (!tenantProfile) {
                        this.router.navigate(['userSettings'])
                        return false;
                    }
                    if (!tenantProfile.suspendedAt) {
                        this.router.navigate(['dashboard'])
                        return false
                    }
                    return true;
                } else {
                    this.router.navigate(['userSettings'])
                    return false;
                }
            })
        )
    }
}

